<template>
  <div class="d-flex w-full " v-if="params.value!=='-'&&params.value !== null&&params.value !== undefined ">
    <p class=""> {{ params.value }}</p>
   
  </div>
  <div v-else class="d-flex w-full justify-content-center">
 <p> -</p>
  </div>
</template>

<script>
export default {
  mounted() {
    // console.log("params", this.params);
  },
  methods: {}
};
</script>
